(() => {
  let start = null;
  let dragged = false;

  document.addEventListener('pointerdown', event => {
    const slider = event.target.closest('.clerae-card-slider');
    if (!slider || event.button !== 0) return;

    start = {
      slider,
      x: event.clientX,
      y: event.clientY
    };

    dragged = false;
  }, { passive: true });

  document.addEventListener('pointermove', event => {
    if (!start) return;

    if (
      Math.abs(event.clientX - start.x) > 7 ||
      Math.abs(event.clientY - start.y) > 7
    ) {
      dragged = true;
    }
  }, { passive: true });

  document.addEventListener('click', event => {
    if (
      dragged &&
      start &&
      event.target.closest('.clerae-card-slider') === start.slider
    ) {
      event.preventDefault();
      event.stopPropagation();
    }

    start = null;
    dragged = false;
  }, true);

  document.addEventListener('pointercancel', () => {
    start = null;
    dragged = false;
  });
})();